import { netImpactLensTexts } from '@upright/ui/common/upright/core/impact-lenses/net-impact/texts';
import { KBUrl, TooltipReadMoreKbLink } from '@upright/ui/common/upright/kb-urls';

export const materialityLensTexts = {
  SourceDescription: netImpactLensTexts.SourceDescription,
  SourceTooltipContent: () => (
    <>
      <div>
        TODO description for CSRD DMA
        <TooltipReadMoreKbLink
          href={KBUrl.METHODOLOGY_SDGS}
          text="Read more about Upright's materiality assessment methodology"
        />
      </div>
    </>
  ),
  LensTitle: () => <>Double materiality</>,
  LensDescription: () => <>Materiality assessment in line with CSRD</>,
  LensTooltipContent: () => <>TODO CSRD explanation</>,
};
